//import $ from 'jquery';
$(document).ready(function(){
  $('.c-accordion__title').on('click', function () {
    let $this = $(this);
    let $target = $(`#${$this.attr('aria-controls')}`);
    let $parent = $this.closest('.c-accordion__item');
    let open = $this.attr('aria-expanded') === 'true';
  
    if (open) {
      $this.attr('aria-expanded', 'false');
      $parent.removeClass('is-open');
      $target.slideUp(200, function () {
        $target.attr('hidden', 'hidden')
      });
    } else {
      $this.attr('aria-expanded', 'true');
      $parent.addClass('is-open');
      $target.slideDown(200);
      $target.prop('hidden', false);
    }
  });
});
